<template>
	<div>
		<top />
		<div class="container">
			<div class="content">
				<!-- <div class="title">免责声明</div> -->
				<div class="text-area" v-html="content"></div>
				<!-- <quillEditor v-model="content" /> -->
			</div>
		</div>
		<foot />
	</div>
</template>
<script>
	import top from "../../components/common/header.vue";
	import foot from "../../components/common/footer.vue";
	import {
		clauseData
	} from "../../request/api";
	export default {
		components: {
			top,
			foot,
		},
		data() {
			return {
				content: "",
				type: "",
			};
		},
		created() {
			this.type = this.$route.query.type
			if (this.type == 'exclusivesigning') {
				document.title = '以图绘图印花设计网-以图绘图网声明';
			} else if (this.type == 'loginterms') {
				document.title = '以图绘图印花设计网-条款协议';
			} else if (this.type == 'copyrightissues') {
				document.title = '以图绘图印花设计网-版权问题';
			} else if (this.type == 'aboutus') {
				document.title = '以图绘图印花设计网-关于我们';
			} else if (this.type == 'uploadproblem') {
				document.title = '以图绘图印花设计网-上传作品问题';
			} else if (this.type == 'salesproblems') {
				document.title = '以图绘图印花设计网-售前售后问题';
			} else if (this.type == 'fordesigners') {
				document.title = '以图绘图印花设计网-设计师行为准则';
			} else if (this.type == 'buyerproblem') {
				document.title = '以图绘图印花设计网-买家问题';
			} else if (this.type == 'sellerissues') {
				document.title = '以图绘图印花设计网-卖家问题';
			} else {
				document.title = '以图绘图印花设计网';
			}
			this.getClauseData();
		},
		watch: {
			$route: {
				handler() {
					this.type = this.$route.query.type;
					this.getClauseData();
					//深度监听，同时也可监听到param参数变化
				},
				deep: true,
			},
		},
		methods: {
			getClauseData() {
				clauseData({
					type: this.type,
				}).then((res) => {
					// console.log(res.data);
					this.content = this.showHtml(res.data);
					console.log(this.content)
				});
			},
			showHtml(str) {
				return str.replace(str ? /&(?!#?\w+;)/g : /&/g, "&amp;").replace(/&lt;/g, "<").replace(/&gt;/g, ">")
					.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;nbsp;/g, "\u3000");
			},
		},
	};
</script>
<style lang="less" scoped>
	.container {
		width: 100%;
		min-width: 1280px;

		.content {
			width: 1280px;
			min-height: 22.2vh;
			margin: 0 auto;
			background: #fff;
			display: flex;
			flex-direction: column;
			align-items: center;
			padding-top: 37px;
			padding-bottom: 139px;
			margin-top: 43px;
			margin-bottom: 80px;
			padding-left: 112px;
			padding-right: 76px;
		}
	}
</style>